import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminSetup from "@/pages/AdminSetup";
import AdminDashboard from "@/pages/AdminDashboard";
import CustomerPortal from "@/pages/CustomerPortal";
import ResetPassword from "@/pages/ResetPassword";
import FleetPortal from "@/pages/FleetPortal";
import SeoPage, { NotFound } from "@/pages/SeoPage";
import { RouteSeo } from "@/components/RouteSeo";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <RouteSeo />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/our-services" element={<SeoPage />} />
          <Route path="/bmw-coding-programming" element={<SeoPage />} />
          <Route path="/breakdown-help" element={<SeoPage />} />
          <Route path="/about-us" element={<SeoPage />} />
          <Route path="/contact" element={<SeoPage />} />
          <Route path="/our-work" element={<SeoPage />} />
          <Route path="/portal" element={<CustomerPortal />} />
          <Route path="/portal/reset" element={<ResetPassword />} />
          <Route path="/fleet" element={<FleetPortal />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/setup" element={<AdminSetup />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster theme="dark" position="bottom-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
